export default __webpack_public_path__ + "static/font-04fd1c908d1561620e7867f4d860e3d9.ttf";